export const getPosts = () => 'blog/posts/';

export const getBlogCategories = () => 'blog/categories/';